<template>
    <div v-if="globalErrors" class="schema-global-errors">
        <div class="controls" v-for="(errorlist, index) in globalErrors" :key="index">
            <div class="text-error" v-for="(error, indx) in errorlist" :key="indx">{{error}}</div>
        </div>
    </div>
</template>

<script>

const globalErrorKeys = ['non_field_errors',];
export default {
    name: "SchemaFormGlobalErrors",
    props: {
        errors: {
            type: Object,
        }
    },
    computed: {
        globalErrors() {
            const globals = [];
            globalErrorKeys.forEach(key => {
                if (key in this.errors) {
                    globals.push(this.errors[key]);
                }
            });
            return globals;
        },
    }
}
</script>

<style>
.schema-global-errors {
    padding-top: 10px;
}
</style>